import {
  TableCell,
  TableRow,
  TextField,
  Autocomplete,
  IconButton,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  createFilterOptions,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";

export default function TarjetaRow({
  tarjeta,
  index,
  tiposTarjeta,
  nombresTarjeta,
  marcas = [],
  onUpdate,
  onRemove,
  handleImporteChange,
}) {
  const [localImporte, setLocalImporte] = useState(tarjeta.importe || "");

  const filterOptions = createFilterOptions({
    stringify: (option) => `${option.nombre} ${option.codigo_bcra}`,
  });

  useEffect(() => {
    setLocalImporte(tarjeta.importe || "");
  }, [tarjeta]);

  return (
    <TableRow>
      <TableCell>
        <FormControl size="small" fullWidth>
          <Select
            value={tarjeta.tipo_id || ""}
            onChange={(e) => onUpdate(index, "tipo_id", e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Tipo
            </MenuItem>
            {tiposTarjeta.map((tipo) => (
              <MenuItem key={tipo.id} value={tipo.id}>
                {tipo.valor}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </TableCell>

      <TableCell>
        <FormControl
          size="small"
          fullWidth
          error={parseFloat(tarjeta.importe) > 0 && !tarjeta.marca_id}
        >
          <Select
            value={tarjeta.marca_id || ""}
            onChange={(e) => onUpdate(index, "marca_id", e.target.value)}
            displayEmpty
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="" disabled>
              Marca
            </MenuItem>
            {marcas.map((marca) => (
              <MenuItem key={marca.id} value={marca.id}>
                {marca.marca}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </TableCell>

      <TableCell>
        <Autocomplete
          options={nombresTarjeta}
          filterOptions={filterOptions}
          noOptionsText="No hay opciones"
          getOptionLabel={(option) => {
            if (typeof option === "string") return option;
            return `${option.nombre} (${option.codigo_bcra})`;
          }}
          value={nombresTarjeta.find((b) => b.id === tarjeta.banco_id) || null}
          onChange={(e, newValue) => {
            const id =
              typeof newValue === "string" ? null : newValue?.id || null;

            onUpdate(index, "banco_id", id);
          }}
          onInputChange={(e, value) => {
            const match = nombresTarjeta.find((b) => b.codigo_bcra === value);

            if (match) {
              onUpdate(index, "banco_id", match.id);
            }
          }}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => (
            <TextField {...params} placeholder="Seleccionar" size="small" />
          )}
          size="small"
          sx={{ minWidth: 150 }}
        />
      </TableCell>

      <TableCell>
        <TextField
          value={tarjeta.lote}
          onChange={(e) => {
            const value = e.target.value;
            if (isNaN(value) || value === ".") return;
            onUpdate(index, "lote", value);
          }}
          size="small"
          inputProps={{ maxLength: 3 }}
          sx={{ minWidth: 80 }}
        />
      </TableCell>

      <TableCell>
        <TextField
          value={tarjeta.cupon}
          onChange={(e) => {
            const value = e.target.value;
            if (isNaN(value) || value === ".") return;
            onUpdate(index, "cupon", value);
          }}
          inputProps={{ maxLength: 4 }}
          size="small"
          sx={{ minWidth: 80 }}
        />
      </TableCell>

      <TableCell>
        <TextField
          value={tarjeta.ultimos4}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 4);
            onUpdate(index, "ultimos4", value);
          }}
          placeholder="0000"
          size="small"
          inputProps={{ maxLength: 4 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">****</InputAdornment>
            ),
          }}
          sx={{ minWidth: 110 }}
        />
      </TableCell>

      <TableCell>
        <TextField
          type="number"
          onWheel={(e) => e.target.blur()}
          sx={{
            "& input[type=number]": {
              MozAppearance: "textfield", // Firefox
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            minWidth: 100,
          }}
          value={localImporte}
          onChange={(e) => setLocalImporte(e.target.value)}
          onBlur={(e) =>
            handleImporteChange(e, (value) => onUpdate(index, "importe", value))
          }
          placeholder="0.00"
          size="small"
        />
      </TableCell>

      <TableCell>
        <IconButton size="small" color="error" onClick={() => onRemove(index)}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
